<template>
    <v-text-field
        :class="inputClass || undefined"
        :name="name"
        :value="value | decimalComma"
        @input="(val) => $emit('input', val.toString().replace(',', '.'))"
        @change="onChange"
        :suffix="suffix"
        :counter="counter"
        :label="label"
        :rules="rules"
        :maxlength="maxlength"
        :outlined="outlined"
        :dense="dense"
        :readonly="readonly"
        :hide-details="hideDetailsResolved"
    ></v-text-field>
</template>
<script>
export default {
    inheritAttrs: false,
    props: [
        "value",
        "error-messages",
        "label",
        "maxlength",
        "rules",
        "counter",
        "suffix",
        "name",
        "outlined",
        "dense",
        "readonly",
        "hideDetails",
        "inputClass",
    ],
    computed: {
        hideDetailsResolved() {
            if (this.hideDetails !== undefined) {
                return this.hideDetails;
            }
            return this.$attrs.hideDetails !== undefined
                ? this.$attrs.hideDetails
                : undefined;
        },
    },
    filters: {},
    methods: {
        onChange(val) {
            this.$emit("change", val);
        },
    },
};
</script>
